import React, { useState, useEffect } from "react";
import Auth from "./ProtectedRoutes/Auth";
import NotLogInAuth from "./ProtectedRoutes/NotLogInAuth";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
//import { Routes, Route } from "react-router-dom";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/home";
import UploadFile from "./pages/upload-file";
import CreateFiles from "./pages/create-files";
import ViewOneFiles from "./pages/view-one-file";
import BlankForm from "./pages/blank-form";
import CreateForm from "./pages/create-form";
import AfterSubmittedForm from "./pages/after-submitted-form";
import ViewForms from "./pages/view-forms";
import Trash from "./pages/trash";
import ViewSignedForms from "./pages/view-signed-forms";
import ChangePassword from "./pages/change-password";
import Notifications from "./pages/notifications";
import FormPreview from "./pages/form-preview";
import FormPreview2 from "./pages/form-preview2";
import ViewUsers from "./pages/view-users";
import CreateUser from "./pages/create-user";
import EditUser from "./pages/edit-user";
import EditForm from "./pages/edit-form";
import ViewOneForm from "./pages/view-one-form";
import EditTerm from "./pages/edit-term";
import Hsitory from "./pages/history";
import ViewOneHistory from "./pages/view-one-history";

function App() {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Retrieve user data from local storage
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);
  }, []);

  return (
    <div>
      <Routes>
        <Route element={<NotLogInAuth />}>
          <Route path="/" element={<Home />} />
        </Route>

        <Route element={<Auth />}>
          <Route path="/upload-file" element={<UploadFile />} />
          <Route path="/create-files" element={<CreateFiles />} />
          <Route path="/view-one-file/:fileId" element={<ViewOneFiles />} />
          <Route path="/blank-form" element={<BlankForm />} />
          <Route path="/edit-form/:fileId" element={<EditForm />} />
          <Route path="/create-form/:fileId" element={<CreateForm />} />
          <Route
            path="/after-submitted-form"
            element={<AfterSubmittedForm />}
          />
          <Route path="/view-forms" element={<ViewForms />} />
          <Route path="/trash" element={<Trash />} />
          <Route path="/view-signed-forms" element={<ViewSignedForms />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/history/:fileId" element={<Hsitory />} />
          <Route path="/users" element={<ViewUsers />} />
          <Route path="/create-user" element={<CreateUser />} />
          <Route path="/users/:userId" element={<EditUser />} />
          <Route path="/users/:userId" element={<EditUser />} />
          <Route path="/edit-term" element={<EditTerm />} />
          <Route path="/view-one-form/:fileId" element={<ViewOneForm />} />
          <Route
            path="/view-one-history/:fileId"
            element={<ViewOneHistory />}
          />
        </Route>

        <Route path="/form-preview/:form_key" element={<FormPreview />} />
        <Route path="/form-preview2" element={<FormPreview2 />} />
      </Routes>
    </div>
  );
}

export default App;
